import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  mixins: [crud],

  resourcePath: 'v1/patient/scheduling/schedules/statistics/status'
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/agendas-statistics/resources/index.js